import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ViewTooltipComingSoon } from '@/pages/_base/views/ViewTooltipComingSoon';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { WSTableUserCreditLimits } from './table_credit_limit/WSTableUserCreditLimits';
import { WSCheckboxNotifyOwnerAboutReachingCreditLimit } from './WSCheckboxNotifyOwnerAboutReachingCreditLimit';

export function TabSettingsWorkspaceCreditsLimits() {
  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.CREDITS_LIMITS} required_owner_access>
      <div
        className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground overflow-auto"
        style={{ height: `calc(100vh - ${CONSTANTS__client.TOPBAR_HEIGHT}px` }}
      >
        <ViewTooltipComingSoon>
          <WSCheckboxNotifyOwnerAboutReachingCreditLimit />
        </ViewTooltipComingSoon>

        <WSTableUserCreditLimits />
      </div>
    </TabSettingsWorkspaceWrapper>
  );
}
